/*LIBRARY*/
import { useRef, useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/
import ICON_FULL_RAW from "../../Assets/jsx/ICON_FULL_RAW";
import ICON_MINIMIZE_RAW from "../../Assets/jsx/ICON_MINIMIZE_RAW";
import ICON_CLOSE_X_2 from "../../Assets/jsx/ICON_CLOSE_X_2";

/*FUNCTION*/

/*DATA*/

/*CONST*/
const min_height = window.innerHeight * 0.1;
const max_height = window.innerHeight * 1;
const minimize_height = 319; //minimize_height

const BOTTOM_BAR_CONTAINER = ({
  properties,
  set_value_properties,
  set_value_layer,
  content,
  is_open,
  height_var,
  drag_var,
}) => {
  const height_value = properties[height_var];
  const drag_value = properties[drag_var];
  const {
    is_mobile,
    sidebar_left_status,
    sidebar_right_status,
    bottom_bar_full,
  } = properties;

  const drag_info_ref = useRef({
    initial_y: 0,
    initial_height: 0,
    last_y: 0,
    last_time: 0,
  });

  const on_close_table = useCallback(() => {
    set_value_layer({
      key: "tableStatus",
      value: false,
    });
    set_value_properties({
      key: "sidebar_left_status",
      value: true,
    });
    set_value_properties({
      key: "sidebar_right_status",
      value: true,
    });
  }, [set_value_layer, set_value_properties]);

  const set_sidebar_height = useCallback(
    (value) => {
      set_value_properties({ key: height_var, value });
      if (value < min_height) {
        on_close_table();
      }
    },
    [set_value_properties, height_var, on_close_table]
  );

  const set_is_dragging = useCallback(
    (value) => {
      set_value_properties({ key: drag_var, value });
    },
    [set_value_properties, drag_var]
  );

  const handle_mouse_down = (e) => {
    e.preventDefault();
    set_is_dragging(true);
    drag_info_ref.current = {
      initial_y: e.clientY,
      initial_height: height_value,
      last_y: e.clientY,
      last_time: Date.now(),
    };
    window.addEventListener("mousemove", handle_mouse_move);
    window.addEventListener("mouseup", handle_mouse_up);
  };

  const handle_mouse_up = () => {
    set_is_dragging(false);
    window.removeEventListener("mousemove", handle_mouse_move);
    window.removeEventListener("mouseup", handle_mouse_up);
  };

  const handle_touch_start = (e) => {
    set_is_dragging(true);
    drag_info_ref.current = {
      initial_y: e.touches[0].clientY,
      initial_height: height_value,
      last_y: e.touches[0].clientY,
      last_time: Date.now(),
    };
    window.addEventListener("touchmove", handle_touch_move, { passive: false });
    window.addEventListener("touchend", handle_touch_end);
  };

  const handle_touch_end = () => {
    set_is_dragging(false);
    window.removeEventListener("touchmove", handle_touch_move);
    window.removeEventListener("touchend", handle_touch_end);
  };

  const apply_drag_height = (new_height, velocity = 0) => {
    if (new_height >= min_height && new_height <= max_height) {
      set_sidebar_height(new_height);
      set_value_properties({
        key: "bottom_bar_full",
        value: false,
      });
    }
    if (
      (velocity > 0.3 && new_height < min_height + 60) ||
      new_height < min_height + 10
    ) {
      on_close_table();
    }
  };

  const on_full = () => {
    set_sidebar_height(window.innerHeight);
    set_value_properties({
      key: "bottom_bar_full",
      value: true,
    });
    set_value_properties({
      key: "sidebar_left_status",
      value: false,
    });
    set_value_properties({
      key: "sidebar_right_status",
      value: false,
    });
  };

  const on_minimize = () => {
    set_sidebar_height(minimize_height);
    set_value_properties({
      key: "bottom_bar_full",
      value: false,
    });
    set_value_properties({
      key: "sidebar_left_status",
      value: true,
    });
    set_value_properties({
      key: "sidebar_right_status",
      value: true,
    });
  };

  const handle_mouse_move = (e) => {
    const deltaY = e.clientY - drag_info_ref.current.initial_y;
    const new_height = drag_info_ref.current.initial_height - deltaY;
    apply_drag_height(new_height);
  };

  const handle_touch_move = (e) => {
    e.preventDefault();
    const current_y = e.touches[0].clientY;
    const deltaY = current_y - drag_info_ref.current.initial_y;
    const new_height = drag_info_ref.current.initial_height - deltaY;
    const now = Date.now();
    const time_diff = now - drag_info_ref.current.last_time;
    const y_diff = current_y - drag_info_ref.current.last_y;
    const velocity = y_diff / time_diff;
    drag_info_ref.current.last_y = current_y;
    drag_info_ref.current.last_time = now;
    apply_drag_height(new_height, velocity);
  };

  let style = {};
  if (is_mobile) {
    style = {
      bottom: "0",
      left: "0",
      width: "100vw",
    };
  } else {
    if (sidebar_left_status && !sidebar_right_status) {
      style = {
        bottom: "0",
        left: "318px",
        width: "calc(100vw - 318px)",
      };
    }
    if (!sidebar_left_status && sidebar_right_status) {
      style = {
        bottom: "0",
        left: "0",
        width: "calc(100vw - 352px)",
      };
    }
    if (!sidebar_left_status && !sidebar_right_status) {
      style = {
        bottom: "0",
        left: "0",
        width: "100vw",
      };
    }
    if (sidebar_left_status && sidebar_right_status) {
      style = {
        bottom: "0",
        left: "318px",
        width: "calc(100vw - 670px)",
      };
    }
  }
  const bottom_bar = (
    <main
      style={{
        zIndex: 3,
        position: "fixed",
        backgroundColor: "rgba(255, 255, 255, 1)",
        height: `${height_value}px`,
        boxSizing: "border-box",
        overflow: "hidden",
        boxShadow: "0 -6px 10px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        transition: drag_value ? "none" : "all 0.3s ease-in-out",
        ...style,
      }}
    >
      <section
        style={{
          width: "100%",
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "row-resize",
          flexShrink: 0,
          position: "relative",
        }}
        onMouseDown={handle_mouse_down}
        onTouchStart={handle_touch_start}
      >
        <aside
          style={{
            position: "absolute",
            top: "17px",
            left: "6px",
            transform: "translateY(-50%)",
            display: "flex",
            gap: "6px",
          }}
        >
          <button
            id="action_close"
            className="cursor_pointer background_black"
            style={{
              height: "24px",
              width: "31px",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => on_close_table()}
          >
            <ICON_CLOSE_X_2 color="#fff" style={{ width: "13px" }} />
          </button>
        </aside>
        <button
          id="action_drag"
          style={{
            width: drag_value ? "111px" : "35px",
            height: drag_value ? "17px" : "5px",
            backgroundColor: drag_value ? "#000" : "#ccc",
            borderRadius: "2em",
            transition: "background-color 0.2s ease-in-out",
          }}
        />
        <aside
          style={{
            position: "absolute",
            top: "17px",
            right: "6px",
            transform: "translateY(-50%)",
            display: "flex",
            gap: "6px",
          }}
        >
          {bottom_bar_full ? (
            <button
              id="action_minimize"
              className="cursor_pointer background_black"
              style={{
                height: "24px",
                width: "31px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => on_minimize()}
            >
              <ICON_MINIMIZE_RAW color="#fff" style={{ width: "13px" }} />
            </button>
          ) : (
            <button
              id="action_full_screen"
              className="cursor_pointer background_black"
              style={{
                height: "24px",
                width: "31px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => on_full()}
            >
              <ICON_FULL_RAW color="#fff" style={{ width: "13px" }} />
            </button>
          )}
        </aside>
      </section>
      <section
        style={{ flexGrow: 1, overflowY: "hidden", overflowX: "hidden" }}
      >
        {content}
      </section>
    </main>
  );

  let final_content;

  if (is_open) {
    final_content = bottom_bar;
  } else {
    final_content = null;
  }

  return <main>{final_content}</main>;
};

const map_state_to_props = (state) => ({
  layer: state.layer,
  properties: state.properties,
});

export default connect(map_state_to_props, {
  set_value_properties,
  set_value_layer,
})(BOTTOM_BAR_CONTAINER);
